var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1669_5247)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22857 0C4.94441 0 4.67189 0.112882 4.47096 0.313814C4.27002 0.514746 4.15714 0.787268 4.15714 1.07143V5.625C4.15714 5.90916 4.27002 6.18168 4.47096 6.38261C4.67189 6.58355 4.94441 6.69643 5.22857 6.69643H9.78214C10.0663 6.69643 10.3388 6.58355 10.5398 6.38261C10.7407 6.18168 10.8536 5.90916 10.8536 5.625V1.07143C10.8536 0.787268 10.7407 0.514746 10.5398 0.313814C10.3388 0.112882 10.0663 0 9.78214 0L5.22857 0ZM1.07143 8.30357C0.787268 8.30357 0.514746 8.41645 0.313814 8.61739C0.112882 8.81832 0 9.09084 0 9.375L0 13.9286C0 14.2127 0.112882 14.4853 0.313814 14.6862C0.514746 14.8871 0.787268 15 1.07143 15H5.625C5.90916 15 6.18168 14.8871 6.38261 14.6862C6.58355 14.4853 6.69643 14.2127 6.69643 13.9286V9.375C6.69643 9.09084 6.58355 8.81832 6.38261 8.61739C6.18168 8.41645 5.90916 8.30357 5.625 8.30357H1.07143ZM8.30357 9.375C8.30357 9.09084 8.41645 8.81832 8.61739 8.61739C8.81832 8.41645 9.09084 8.30357 9.375 8.30357H13.9286C14.2127 8.30357 14.4853 8.41645 14.6862 8.61739C14.8871 8.81832 15 9.09084 15 9.375V13.9286C15 14.2127 14.8871 14.4853 14.6862 14.6862C14.4853 14.8871 14.2127 15 13.9286 15H9.375C9.09084 15 8.81832 14.8871 8.61739 14.6862C8.41645 14.4853 8.30357 14.2127 8.30357 13.9286V9.375Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1669_5247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.7fd6cfa86b2252eb1b0b633338402c9d.svg";
export { ForwardRef as ReactComponent };